import React from "react";
import { Navbar } from "../components/Navbar";
import { PageHeader } from "../components/PageHeader";
import { ProductCategories } from "../components/ProductCategories";
import { Marquee } from "../components/Marquee";
import { CtaBanner } from "../components/CtaBanner";
import { Footer } from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";
import { productImages } from "../data/images";

export default function Products() {
  const { t, lang } = useLang();
  return (
    <main className="bg-[#F9F8F6] text-[#1A1A1A] font-body" data-testid="page-products">
      <Navbar transparentOnHome={false} />
      <PageHeader
        eyebrow={t("products.eyebrow")}
        title={lang === "de" ? "Fünf Welten unter Ihren Füßen." : "Five worlds beneath your feet."}
        subtitle={t("products.subtitle")}
        image={productImages.parquet}
      />
      <ProductCategories hideHeader />
      <Marquee />
      <CtaBanner variant="dark" />
      <Footer />
    </main>
  );
}
